import { DOCUMENT_NAMES } from "../constants/documents";
import { convertFileInfoToAttachment } from "./loan";

export function changeFileName(file, newName) {
  return new File([file], newName, { type: file.type });
}

export async function convertFileToBase64(file) {
  return new Promise((resolve) => {
    const fileReader = new FileReader();

    fileReader.onloadend = () => {
      const base64String = fileReader.result;

      resolve(base64String);
    };

    fileReader.readAsDataURL(file);
  });
}

export async function convertFileToFileInfo(file) {
  return new Promise((resolve) => {
    if (!(file instanceof File)) throw new Error("Invalid file parameter");

    const fileReader = new FileReader();

    fileReader.onloadend = () => {
      const base64String = fileReader.result;

      resolve({
        base64: base64String,
        file,
      });
    };

    fileReader.readAsDataURL(file);
  });
}

export async function convertFileToAttachment(file, documentId) {
  const fileInfo = await convertFileToFileInfo(file);

  return convertFileInfoToAttachment(fileInfo, file.name, documentId);
}

export async function syncFileNameWithBankName(
  bankName,
  fileInfo,
  fileInfoSetter
) {
  if (!bankName) return;

  if (!fileInfo?.file) return;

  const changedFileName = changeFileName(
    fileInfo.file,
    `${DOCUMENT_NAMES.STATEMENT}${bankName}`
  );

  const newFileInfo = await convertFileToFileInfo(changedFileName);

  fileInfoSetter(newFileInfo);
}

export function convertBase64toFile(base64, filename) {
  var arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}
